module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "photo-info publish-main"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "size": "small",
      "rules": _vm.rules
    }
  }, [_c('title-area', {
    attrs: {
      "title": "图标素材",
      "hint": "要求：1.等边矩形；2.PNG、JPG；3.尺寸≧512px；4.不超过1M"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "icolist"
    }
  }, [_c('div', {
    staticClass: "photo-upload-wrap"
  }, [_c('div', {
    staticClass: "file_box",
    style: ({
      backgroundImage: 'url(' + _vm.fileImg + ')'
    })
  }, [_c('form', {
    attrs: {
      "id": "subform",
      "enctype": "multipart/form-data",
      "method": "post",
      "action": "/zklccloud/uploadImages"
    }
  }, [_c('input', {
    class: {
      'vis-hide': _vm.classVisFlag
    },
    attrs: {
      "type": "file",
      "name": "file",
      "id": "uploadImage",
      "disabled": _vm.hidsubv
    },
    on: {
      "change": function($event) {
        return _vm.uploadImage()
      },
      "click": _vm.disabledF
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "type",
      "value": "2"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "photo-size"
  }, [_c('li', {
    staticClass: "items"
  }, [_c('section', {
    staticClass: "size",
    staticStyle: {
      "width": "128px",
      "height": "128px"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.images128
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "title color_9"
  }, [_vm._v("128 x 128")])]), _vm._v(" "), _c('li', {
    staticClass: "items"
  }, [_c('section', {
    staticClass: "size",
    staticStyle: {
      "width": "72px",
      "height": "72px"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.images72
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "title color_9"
  }, [_vm._v("72 x 72")])]), _vm._v(" "), _c('li', {
    staticClass: "items"
  }, [_c('section', {
    staticClass: "size",
    staticStyle: {
      "width": "64px",
      "height": "64px"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.images64
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "title color_9"
  }, [_vm._v("64 x 64")])]), _vm._v(" "), _c('li', {
    staticClass: "items"
  }, [_c('section', {
    staticClass: "size",
    staticStyle: {
      "width": "32px",
      "height": "32px"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.images32
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "title color_9"
  }, [_vm._v("32 x 32")])])]), _vm._v(" "), _c('ul', {
    staticClass: "number-size"
  }, [_c('li', [_vm._v("更多尺寸：")]), _vm._v(" "), _vm._l((_vm.form.icolist), function(icon) {
    return (icon.viewSize != 32 && icon.viewSize != 64 && icon.viewSize != 72 && icon.viewSize != 128) ? _c('li', {
      staticClass: "items"
    }, [_vm._v(_vm._s(icon.viewSize) + "*" + _vm._s(icon.viewSize))]) : _vm._e()
  })], 2)])], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "应用截图",
      "hint": "请上传2-5张图片，大于500px，格式PNG\\JPG， 2M以内大小",
      "margin-left": 5,
      "dashed": false
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "paths"
    }
  }, [_c('div', {
    staticClass: "screenshot_container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row publick_form_box"
  }, [_vm._l((_vm.form.paths), function(path, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.paths.length != 0),
        expression: "form.paths.length!=0"
      }],
      staticClass: "img_box pos-relative",
      attrs: {
        "disabled": _vm.hidsubv
      }
    }, [_c('img', {
      attrs: {
        "src": path
      }
    }), _vm._v(" "), (!_vm.hidsubv) ? _c('i', {
      staticClass: "glyphicon ico_del",
      on: {
        "click": function($event) {
          return _vm.delImg(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.paths.length <= 4),
      expression: "form.paths.length<=4"
    }],
    staticClass: "file_box",
    attrs: {
      "disabled": _vm.hidsubv
    }
  }, [_c('form', [_c('input', {
    attrs: {
      "type": "file",
      "name": "file",
      "id": "addAppImage",
      "disabled": _vm.hidsubv
    },
    on: {
      "change": function($event) {
        return _vm.addAppImage($event)
      }
    }
  })])])], 2)])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-80b09958"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/publish_apply/module/photo_info.vue
// module id = 1271
// module chunks = 1